import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import { Entity } from '@/store/modules/entities/entitiesTypes'
import { ContextName } from '@/store/types/storeGlobalTypes'
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'
import useSelectedRegister from '@/composables/useSelectedRegister'
import useStage from '@/composables/useStage'
import useEntity from '@/composables/useEntity'
import useEndpoints from '@/composables/useEndpoints'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'
import useTruncation from '@/composables/useTruncation'

// CONSTS

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpedientGlobalVisionTopBarComponent',
  setup(__props) {

const contexts = {
  topBarContext: ContextName.EXPEDIENT_GLOBAL_VISION_TOP_BAR,
  expedientContext: ContextName.EXPEDIENTS
}

// DATA
const showSpinner = ref(true)

// COMPOSABLES
const expedientRegister = useSelectedRegister({ entityName: contexts.expedientContext })
const topBarRegister = useSelectedRegister({ entityName: contexts.topBarContext })
const { selectedRegisterId: selectedExpedientId, loadSelectedRegisterWithPost } = expedientRegister
const { selectedRegisterData } = topBarRegister

const { expedientStage } = useStage()
const { getEntity } = useEntity({ entityName: contexts.expedientContext })
const { getEndpoints } = useEndpoints()

// COMPUTED
const selectedExpedientTopBarData = computed(() => {
  return selectedRegisterData.value?.globalVisionTopBar || []
})

const firstRowData = computed(() => selectedExpedientTopBarData.value.slice(0, 2))
const secondRowData = computed(() => selectedExpedientTopBarData.value.slice(2))
const expedientStageState = computed(() => expedientStage.value)

// METHODS
const fetchGlobalVisionTopBarInfo = async () => {
  showSpinner.value = true

  const entity: Entity = getEntity()
  const entityType = entity.type
  const endpoints = getEndpoints(entityType)
  const endpoint = endpoints.get

  await loadSelectedRegisterWithPost({
    endpoint,
    context: contexts.topBarContext,
    post: {
      idExpedient: selectedExpedientId.value,
      source: contexts.topBarContext,
      idStage: expedientStageState.value
    }
  })

  showSpinner.value = false
}

const getSpecialClasses = (index: number) => {
  const classMap: Record<number, string> = {
    2: 'procedure',
    3: 'stage',
    4: 'situation'
  }

  return classMap[index] || ''
}

const isValidData = (data: any): boolean => {
  return !!data && data !== ' '
}

const { isTruncatedItems, checkTruncation, setRef } = useTruncation({
  items: secondRowData.value
})

// WATCHERS
watch(expedientStageState, () => {
  fetchGlobalVisionTopBarInfo()
})

// INIT
fetchGlobalVisionTopBarInfo()

return { __sfc: true,contexts, showSpinner, expedientRegister, topBarRegister, selectedExpedientId, loadSelectedRegisterWithPost, selectedRegisterData, expedientStage, getEntity, getEndpoints, selectedExpedientTopBarData, firstRowData, secondRowData, expedientStageState, fetchGlobalVisionTopBarInfo, getSpecialClasses, isValidData, isTruncatedItems, checkTruncation, setRef, SpinnerLayerComponent, LexonTooltipComponent }
}

})